export default __webpack_public_path__ + "static/media/468.065a3db2.png";